module.exports = __webpack_public_path__ + "img/wholesale-term-modal-image-06.2e5d90d.svg";